export const whiteTheme = {
  // Background colors
  primaryBg: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 50%, #ffffff 100%)',
  secondaryBg: 'rgba(255, 255, 255, 0.95)',
  tertiaryBg: 'rgba(248, 250, 252, 0.9)',
  modalBg: 'rgba(255, 255, 255, 0.98)',
  
  // Text colors
  primaryText: '#1e293b',
  secondaryText: '#475569',
  tertiaryText: '#64748b',
  mutedText: '#94a3b8',
  
  // Border colors
  primaryBorder: 'rgba(30, 41, 59, 0.1)',
  secondaryBorder: '#e2e8f0',
  accentBorder: 'rgba(59, 130, 246, 0.3)',
  
  // Button colors
  primaryButton: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
  secondaryButton: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
  accentButton: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
  dangerButton: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  
  // Input colors
  inputBg: 'rgba(255, 255, 255, 0.9)',
  inputBorder: 'rgba(30, 41, 59, 0.1)',
  inputFocusBorder: '#3b82f6',
  
  // Card colors
  cardBg: 'rgba(255, 255, 255, 0.95)',
  cardHoverBg: 'rgba(248, 250, 252, 0.98)',
  
  // Shadow colors
  primaryShadow: 'rgba(30, 41, 59, 0.1)',
  accentShadow: 'rgba(59, 130, 246, 0.2)',
  
  // Logo gradient
  logoGradient: 'linear-gradient(135deg, #3b82f6 0%, #10b981 100%)',
  
  // Voice button colors
  voiceButtonIdle: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
  voiceButtonRecording: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
  
  // Quick options colors
  quickOptionBg: 'rgba(255, 255, 255, 0.9)',
  quickOptionHover: 'rgba(248, 250, 252, 0.95)',
  quickOptionBorder: '#e2e8f0',
  quickOptionText: '#475569',
  
  // Business type colors
  businessTypeBg: 'rgba(255, 255, 255, 0.95)',
  businessTypeHover: 'rgba(248, 250, 252, 0.98)',
  businessTypeText: '#475569',
  
  // Modal colors
  modalOverlay: 'rgba(30, 41, 59, 0.4)',
  modalBorder: 'rgba(59, 130, 246, 0.3)',
  
  // Close button colors
  closeButtonBg: 'rgba(239, 68, 68, 0.1)',
  closeButtonBorder: 'rgba(239, 68, 68, 0.2)',
  closeButtonText: '#ef4444',
  closeButtonHover: 'rgba(239, 68, 68, 0.15)',
  
  // Thinking animation colors
  thinkingBg: 'rgba(255, 255, 255, 0.95)',
  thinkingBorder: 'rgba(59, 130, 246, 0.2)',
  nucleusGradient: 'radial-gradient(circle, #3b82f6, #2563eb)',
  electronColor: '#60a5fa',
  
  // Message colors
  userMessageBg: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
  botMessageBg: 'rgba(248, 250, 252, 0.9)',
  messageText: '#1e293b',
  
  // Welcome message colors
  welcomeText: '#475569',
  welcomeSubtext: '#64748b',
  
  // Additional properties needed by ChatHistory component
  primary: '#3b82f6',
  primaryHover: '#2563eb',
  warningBg: 'rgba(245, 158, 11, 0.1)',
  warningBorder: 'rgba(245, 158, 11, 0.2)',
  warningText: '#d97706',
  error: '#ef4444',
  errorBg: 'rgba(239, 68, 68, 0.1)',
  
  // ChatHistory specific properties
  primaryBg: 'rgba(255, 255, 255, 0.95)',
  primaryBgHover: 'rgba(248, 250, 252, 0.98)'
}; 